import classNames from 'classnames';
import { useState } from 'react';
import { Link } from 'wouter';

import { getMediaUrl } from 'utils/assets';

import styles from './ProviderCard.module.scss';

type ProviderCardProps = {
  iconUrl: string;
  displayedName: string;
  className?: string;
};

const ProviderCard = ({
  iconUrl,
  displayedName,
  className,
}: ProviderCardProps) => {
  const [isError, setIsError] = useState(false);

  const handleError = () => {
    setIsError(true);
  };

  return (
    <Link
      className={classNames(styles['provider-card'], className, {
        [styles['with-icon']]: iconUrl,
      })}
      to={`/${encodeURIComponent(displayedName)}`}
      key={displayedName}
    >
      {iconUrl && !isError ? (
        <img
          className={styles.icon}
          src={getMediaUrl(iconUrl, 'game')}
          alt={displayedName}
          onError={handleError}
        />
      ) : (
        <p className={styles.name}>{displayedName}</p>
      )}
    </Link>
  );
};

export default ProviderCard;
